import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { errorFormatter } from '../../utils/error'
import ErrorMsg from '../ErrorMsg'

const RouteErrorBoundary = () => {
  const error = useRouteError()

  return (
    <div className="flex flex-col justify-start w-full h-screen p-4">
      {isRouteErrorResponse(error) ? (
        <ErrorMsg
          title="Error"
          content={`status: ${error.status}, statusText: ${error.statusText}`}
          reloadWindow={true}
        />
      ) : (
        <ErrorMsg
          title="Error"
          content="Failed to render page"
          error={errorFormatter(error)}
          reloadWindow={true}
        />
      )}
    </div>
  )
}

export default RouteErrorBoundary
